/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useState, useMemo, useEffect, useRef } from 'react';
import { Stack } from '@mui/material';
import DialogTextField from 'components/dialog/DialogTextField';
import { useProject } from 'hooks/useProject';

interface ISurveyDescriptiveAnswerProps {
  id: string;
  type: string;
  handleNext: (_type: string, _surveyId: string, _info: any) => void;
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  surveyType: 'survey' | 'surveyAdd';
}
function SurveyDescriptiveAnswer({
  id,
  type,
  handleNext,
  setIsDisabled,
  surveyType,
}: ISurveyDescriptiveAnswerProps): JSX.Element {
  const { progressInfo, surveyResultList, surveyInfoResultList } = useProject();
  const resultList = surveyType === 'surveyAdd' ? surveyResultList : surveyInfoResultList;
  const buttonInfo = useMemo(() => {
    return resultList?.[progressInfo]?.answerResult || '';
  }, [resultList, progressInfo]);

  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setValue(buttonInfo);
    inputRef.current?.focus();
  }, [buttonInfo]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  const handleBlur = () => {
    handleNext(type, id, value);
  };

  useEffect(() => {
    setIsDisabled(value.trim().length === 0);
  }, [setIsDisabled, value]);

  return (
    <Stack direction="column">
      <DialogTextField
        text={value}
        variant="outlined"
        name="content"
        onChange={handleChange}
        placeholder="답변을 입력하세요"
        multiline
        rows={11}
        onBlur={handleBlur}
        marginBottom="0px"
        inputRef={inputRef}
      />
    </Stack>
  );
}

export default memo(SurveyDescriptiveAnswer);
